import { BusinessGroup } from 'components/search/utils';
import { findBusinessGroup } from 'components/search/businessGroups';
import { gql } from '@apollo/client';
import { useEffect } from 'react';
import { useFetchBusinessGroupLazyQuery } from 'generated/graphql';

export const BUSINESS_GROUP_QUERY = gql`
  query FetchBusinessGroup($businessGroupSlug: String!) {
    businessGroupBySlug(businessGroupSlug: $businessGroupSlug) {
      id
      ...BusinessGroup
    }
  }
  fragment BusinessGroup on BusinessGroupEntity {
    businesses {
      id
      name
    }
    id
    name
    groupLevelTags
    groupUrlPageTitle
    slug
  }
`;

export function useBusinessGroup(groupSlug?: string) {
  const [fetchBusinessGroup, { data: businessGroupData, loading }] = useFetchBusinessGroupLazyQuery(
    {
      ssr: false,
    }
  );

  useEffect(() => {
    if (groupSlug && !loading && !businessGroupData) {
      fetchBusinessGroup({
        variables: { businessGroupSlug: groupSlug },
      });
    }
  }, [businessGroupData, fetchBusinessGroup, groupSlug, loading]);
  let businessGroup: BusinessGroup | undefined;
  if (groupSlug) {
    if (businessGroupData) {
      businessGroup = {
        id: businessGroupData?.businessGroupBySlug?.id,
        name: businessGroupData?.businessGroupBySlug?.groupUrlPageTitle,
        slug: businessGroupData?.businessGroupBySlug?.slug,
      } as BusinessGroup;
    } else {
      businessGroup = findBusinessGroup(groupSlug);
    }
  }

  return businessGroup;
}
